import { GasMovementTypes } from "redux/reducers/gasMovementsRequests/types";
import { startRequest, stopRequest, setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import { PROYECT, api_get, api_put, api_delete, api_post } from "services/api";

const {
    GET_GAS_MOVEMENTS_REQUESTS,
    NEW_GAS_MOVEMENT,
    EDIT_GAS_MOVEMENT,
    SET_CONFIG_PAGE_GAS_MOVEMENTS,
    SET_CONFIG_PAGE_GAS_MOVEMENTS_COUNT,
    SET_CONFIG_FILTERED_GAS_MOVEMENTS,
    SET_CONFIG_SORTED_GAS_MOVEMENTS,
    SET_STATION,
    GET_UNITS,
    UPDATE_STATUS,
    DELETE_MOVEMENT
} = GasMovementTypes

const url = `${process.env.REACT_APP_URL}${PROYECT}/inventory-gas-movements`;

export const getGasMovementsRequests = (startDate, endDate, idStation) => {
    const getGasMovements = `${url}?idStation=${idStation}&start=${startDate}&end=${endDate}`;
    return async (dispatch) => {
        dispatch(startRequestComp('GM_RequestsLoading'))
        await api_get(getGasMovements).then(resp => {
            let nRes = resp
            if (resp.length === 0) {
                dispatch(setSnackbar('No hay movimientos de gas', 'info'))
                nRes = []
            }

            dispatch({
                type: GET_GAS_MOVEMENTS_REQUESTS,
                payload: nRes
            })
            // action && action()
        }).catch(err => dispatch(setSnackbar(err)))
        dispatch(stopRequestComp('GM_RequestsLoading'))
    }
}

export const createGasMovement = (body, onClose = null) => {
    return async (dispatch) => {
        dispatch(startRequestComp('GM_newLoading'))
        await api_post(url, body).then(resp => {
            dispatch({
                type: NEW_GAS_MOVEMENT,
                payload: {
                    ...resp,
                    movement: body.movement,
                    movementType: body.movementType,
                    unit: body.unit,
                    employee: resp.employee,
                    status: "PENDIENTE",
                    comment: body.comment
                }
            })
            dispatch(setSnackbar('Creado con éxito', 'success'))
            onClose && onClose()
        }).catch(err => {
            dispatch(setSnackbar(err))
        })
        dispatch(stopRequestComp('GM_newLoading'))
    }
}

export const getUnits = (idStation, filter = null) => {
    const getUnit = `${url}/units/${idStation}${filter ? `?filter=${filter}` : ""}`;
    return async (dispatch) => {
        dispatch(startRequest())
        await api_get(getUnit).then(resp => {
            dispatch({
                type: GET_UNITS,
                payload: resp
            })
            dispatch(stopRequest())
        }).catch(err => {
            dispatch(setSnackbar(err))
            dispatch(stopRequest())
        })
    }
}

export const editGasMovement = (body, form, action=null) => {
    const editUrl = `${url}/${body.id}`;
    return async (dispatch) => {
        dispatch(startRequestComp("GM_approveLoading"))
        await api_put(editUrl, form).then(_resp => {
            dispatch({
                type: EDIT_GAS_MOVEMENT,
                payload: body
            })
            body?.edit && dispatch(setSnackbar('Editado con éxito', 'success'))
            action && action(true)
        }).catch(err => {
            dispatch(setSnackbar(err))
        })
        dispatch(stopRequestComp("GM_approveLoading"))
    }
}


export const submitApproval = (id, status, username, comment = "", action=null, close=null) => {
    const sendRequestUrl = `${url}/${id}/status/${status}`;
    const requestBody = comment ? { comment } : {};
    
    return async (dispatch) => {
        dispatch(startRequestComp("GM_approveLoading"))
        await api_put(sendRequestUrl, requestBody).then(_resp => {
            dispatch({
                type: UPDATE_STATUS,
                payload: { id, status: status ? "AUTORIZADO" : "RECHAZADO", employee: username },
            })
            action && action()
            close && close()
            dispatch(setSnackbar(`${status  ? "Aprobado" : "Rechazado"} con éxito`, 'success'))
        }).catch(err => {
            dispatch(setSnackbar(err))
        })
        dispatch(stopRequestComp("GM_approveLoading"))
    }
}

export const deleteMovement = (id, close = null) => {
    const deleteUrl = `${url}/${id}`
    return async (dispatch) => {
        dispatch(startRequestComp("GM_approveLoading"))
        await api_delete(deleteUrl).then(_resp => {
            dispatch({
                type: DELETE_MOVEMENT,
                payload: id,
            })
            dispatch(setSnackbar('Eliminado con éxito', 'success'))
            close && close()
        }).catch(err => {
            dispatch(setSnackbar(err))
        })
        dispatch(stopRequestComp("GM_approveLoading"))
    }
}

export const saveStation = (station) => {
    return {
        type: SET_STATION,
        payload: station
    }
}

//config columns GasMovements
export const configPageGasMovements = (page) => {
    return { type: SET_CONFIG_PAGE_GAS_MOVEMENTS, payload: page }
}

export const configPageGasMovementsSize = (page) => {
    return {
        type: SET_CONFIG_PAGE_GAS_MOVEMENTS_COUNT,
        payload: page
    }
}

export const configFilterGasMovements = (filter) => {
    return { type: SET_CONFIG_FILTERED_GAS_MOVEMENTS, payload: filter }
}

export const configSortedGasMovements = (sorted) => {
    return { type: SET_CONFIG_SORTED_GAS_MOVEMENTS, payload: sorted }
}